import React, { useState,useEffect } from "react";
import ColorPicker from "../../../components/ColorPicker";
import CssCodeEditor from "../../../components/CssCodeEditor";

const StyleTab = ({updateReviewTabData,reviewTabData}) => {
    const [activeStyleCustomizeElementsTab, setActiveStyleCustomizeElementsTab] = useState("main");
    const [backgroundColor, setBackgroundColor] = useState(reviewTabData.style_background_color);
    const [titleColor, setTitleColor] = useState(reviewTabData.style_widget_title_color);
    const [captionColor, setCaptionColor] = useState(reviewTabData.style_widget_title_caption_color);
    const [linksColor, setLinksColor] = useState(reviewTabData.style_widget_title_links_color);
    const [styleHeaderBackgroundColor, setStyleHeaderBackgroundColor] = useState(reviewTabData.style_header_background_color);
    const [styleHeaderTextColor, setStyleHeaderTextColor] = useState(reviewTabData.style_header_text_color);
    const [styleHeaderWriteReviewBackgroundColor, setStyleHeaderWriteReviewBackgroundColor] = useState(reviewTabData.style_header_write_review_background_color);
    const [styleHeaderWriteReviewTextColor, setStyleHeaderWriteReviewTextColor] = useState(reviewTabData.style_header_write_review_text_color);
    const [activeHeaderReviewButtonType, setHeaderReviewButtonType] = useState(reviewTabData.header_write_review_button_type);
    const [styleHeaderRatingStarsColor, setStyleHeaderRatingStarsColor] = useState(reviewTabData.style_rating_stars_color);
    const [styleHeaderReviewBackgroundColor, setStyleHeaderReviewBackgroundColor] = useState(reviewTabData.style_review_background_color);
    const [styleHeaderReviewTextColor, setStyleHeaderReviewTextColor] = useState(reviewTabData.style_review_text_color);
    const [styleHeaderReviewReadMoreColor, setStyleHeaderReviewReadMoreColor] = useState(reviewTabData.style_read_more_color);
    const [styleHeaderReviewReviewerNameColor, setStyleHeaderReviewReviewerNameColor] = useState(reviewTabData.style_review_reviewer_name_color);
    const [styleHeaderReviewVerifiedBadgeColor, setStyleHeaderReviewVerifiedBadgeColor] = useState(reviewTabData.style_review_verified_badge_color);
    const [styleHeaderReviewDateColor, setStyleHeaderReviewDateColor] = useState(reviewTabData.style_review_date_color);
    const [styleTabReviewButtonColor, setStyleTabReviewButtonColor] = useState(reviewTabData.style_load_more_button_color);
    const [styleTabReviewButtonTextColor, setStyleTabReviewButtonTextColor] = useState(reviewTabData.style_load_more_button_text_color);
    const [styleHeaderReviewSourceIconBackgroundColor, setStyleHeaderReviewSourceIconBackgroundColor] = useState(reviewTabData.style_review_source_icon_color);
    const [selectedStyleTabTitleSizeSpacing, setSelectedStyleTabTitleSizeSpacing] = useState(reviewTabData.style_widget_title_fonts_title_size);
    const [showStyleTabTitleSizeSpacingDropdown, setShowStyleTabTitleSizeSpacingDropdown] = useState(false);

    const [selectedStyleTabCaptionSizeSpacing, setSelectedStyleTabCaptionSizeSpacing] = useState(reviewTabData.style_widget_title_fonts_caption_size);
    const [showStyleTabCaptionSizeSpacingDropdown, setShowStyleTabCaptionSizeSpacingDropdown] = useState(false);

    const [selectedStyleTabRatingSizeSpacing, setSelectedStyleTabRatingSizeSpacing] = useState(reviewTabData.style_review_rating_size);
    const [showStyleTabRatingSizeSpacingDropdown, setShowStyleTabRatingSizeSpacingDropdown] = useState(false);

    const [selectedStyleTabReviewTextFontSizeSpacing, setSelectedStyleTabReviewTextFontSizeSpacing] = useState(reviewTabData.style_review_text_font_size);
    const [showStyleTabReviewTextFontSizeSpacingDropdown, setShowStyleTabReviewTextFontSizeSpacingDropdown] = useState(false);

    const [styleTabCustomCss, setStyleTabCustomCss] = useState(reviewTabData.style_custom_css);
    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateReviewTabData("style_background_color", color.hex);
    };

    // Handlers Title Color Change
    const handleTitleColorChange = (color) => {
        setTitleColor(color.hex);
        updateReviewTabData("style_widget_title_color", color.hex);
    };

    // Handlers Caption Color Change
    const handleCaptionColorChange = (color) => {
        setCaptionColor(color.hex);
        updateReviewTabData("style_widget_title_caption_color", color.hex);
    };

    // Handlers Links Color Change
    const handleLinksColorChange = (color) => {
        setLinksColor(color.hex);
        updateReviewTabData("style_widget_title_links_color", color.hex);
    };

    // Handlers Header Background Color Change
    const handleHeaderBackgroundColorChange = (color) => {
        setStyleHeaderBackgroundColor(color.hex);
        updateReviewTabData("style_header_background_color", color.hex);
    };

    // Handlers Header Text Color Change
    const handleHeaderTextColorChange = (color) => {
        setStyleHeaderTextColor(color.hex);
        updateReviewTabData("style_header_text_color", color.hex);
    };

    // Handlers Header Write Review Background Color Change
    const handleHeaderWriteReviewBackgroundColorChange = (color) => {
        setStyleHeaderWriteReviewBackgroundColor(color.hex);
        updateReviewTabData("style_header_write_review_background_color", color.hex);
    };

    // Handlers Header Write review text Color Change
    const handleHeaderWriteReviewTextColorChange = (color) => {
        setStyleHeaderWriteReviewTextColor(color.hex);
        updateReviewTabData("style_header_write_review_text_color", color.hex);
    };

    // Handlers Stars Color Change
    const handleHeaderRatingStarsColorChange = (color) => {
        setStyleHeaderRatingStarsColor(color.hex);
        updateReviewTabData("style_rating_stars_color", color.hex);
    };

    // Handlers Review Background Color Color Change
    const handleReviewBackgroundColorChange = (color) => {
        setStyleHeaderReviewBackgroundColor(color.hex);
        updateReviewTabData("style_review_background_color", color.hex);
    };

    // Handlers Review Text Color Color Change
    const handleReviewTextColorChange = (color) => {
        setStyleHeaderReviewTextColor(color.hex);
        updateReviewTabData("style_review_text_color", color.hex);
    };

    // Handlers Review Read More Color Change
    const handleReviewReadMoreColorChange = (color) => {
        setStyleHeaderReviewReadMoreColor(color.hex);
        updateReviewTabData("style_read_more_color", color.hex);
    };

    // Handlers Review Reviewer Name Color Change
    const handleReviewReviewerNameColorChange = (color) => {
        setStyleHeaderReviewReviewerNameColor(color.hex);
        updateReviewTabData("style_review_reviewer_name_color", color.hex);
    };

    // Handlers Review Verified Badge Color Change
    const handleReviewVerifiedBadgeColorChange = (color) => {
        setStyleHeaderReviewVerifiedBadgeColor(color.hex);
        updateReviewTabData("style_review_verified_badge_color", color.hex);
    };

    // Handlers Review Date Color Change
    const handleReviewDateColorChange = (color) => {
        setStyleHeaderReviewDateColor(color.hex);
        updateReviewTabData("style_review_date_color", color.hex);
    };

    // Handlers Review Source Icon Background Color Change
    const handleReviewSourceIconBackgroundColorChange = (color) => {
        setStyleHeaderReviewSourceIconBackgroundColor(color.hex);
        updateReviewTabData("style_review_source_icon_color", color.hex);
    };

    // Handlers Review Load Button Background Color Change
    const handleReviewLoadMoreBackgroundColorChange = (color) => {
        setStyleTabReviewButtonColor(color.hex);
        updateReviewTabData("style_load_more_button_color", color.hex);
    };

    // Handlers Review Button Load More Text Color Change
    const handleReviewLoadMoreTextColorChange = (color) => {
        setStyleTabReviewButtonTextColor(color.hex);
        updateReviewTabData("style_load_more_button_text_color", color.hex);
    };
      
    // Handlers Review Title Size Change
    const toggleStyleTabTitleSizeSpacingDropdown = () => {
        setShowStyleTabTitleSizeSpacingDropdown(!showStyleTabTitleSizeSpacingDropdown);
    };
    const handleStyleTabTitleSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabTitleSizeSpacing(spacing);
        setShowStyleTabTitleSizeSpacingDropdown(false);
        updateReviewTabData("style_widget_title_fonts_title_size", spacing); 
    };

    // Handlers Review Caption Size Change
    const toggleStyleTabCaptionSizeSpacingDropdown = () => {
        setShowStyleTabCaptionSizeSpacingDropdown(!showStyleTabCaptionSizeSpacingDropdown);
    };
    const handleStyleTabCaptionSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabCaptionSizeSpacing(spacing);
        setShowStyleTabCaptionSizeSpacingDropdown(false);
        updateReviewTabData("style_widget_title_fonts_caption_size", spacing); 
    };

    // Handlers Review Rating Size Change
    const toggleStyleTabRatingSizeSpacingDropdown = () => {
        setShowStyleTabRatingSizeSpacingDropdown(!showStyleTabRatingSizeSpacingDropdown);
    };
    const handleStyleTabRatingSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabRatingSizeSpacing(spacing);
        setShowStyleTabRatingSizeSpacingDropdown(false);
        updateReviewTabData("style_review_rating_size", spacing); 
    };

    // Handlers Review Review Text Font Size Change
    const toggleStyleTabReviewTextFontSizeSpacingDropdown = () => {
        setShowStyleTabReviewTextFontSizeSpacingDropdown(!showStyleTabReviewTextFontSizeSpacingDropdown);
    };
    const handleStyleTabReviewTextFontSizeSpacingSelect = (spacing) => {
        setSelectedStyleTabReviewTextFontSizeSpacing(spacing);
        setShowStyleTabReviewTextFontSizeSpacingDropdown(false);
        updateReviewTabData("style_review_text_font_size", spacing); 
    };

    // Handle Header Review Button type change
    const handleHeaderReviewButtonTypeChange = (event) => {
        setHeaderReviewButtonType(event.target.value);
        updateReviewTabData("header_write_review_button_type", event.target.value);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateReviewTabData("style_custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    return (
        <div className="side-baar-inner-style">
            {activeStyleCustomizeElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("background")}>Background <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("widget")}>Widget Title <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("header")}>Header <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("rating")}>Rating <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("review")}>Review <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("load_more")}>Load More Button <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("custom_css")}>Custom CSS <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "background" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Background Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={backgroundColor} setColor={setBackgroundColor} onChangeComplete={handleBackgroundColorChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "widget" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Widget Title</span>
                        <h6>Colors</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Title Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={titleColor} setColor={setTitleColor} onChangeComplete={handleTitleColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Caption Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={captionColor} setColor={setCaptionColor} onChangeComplete={handleCaptionColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Links Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={linksColor} setColor={setLinksColor} onChangeComplete={handleLinksColorChange} />
                                </div>
                            </div>
                        </div>
                        <h6>Fonts</h6>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Title Size</span>
                                {/*<div className="font-style">
                                    <button className="normal-style">B</button>
                                    <button className="italic-style">I</button>
                                </div>*/}
                                <em onClick={toggleStyleTabTitleSizeSpacingDropdown}>{selectedStyleTabTitleSizeSpacing}</em>
                                {showStyleTabTitleSizeSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"].map((spacing) => (
                                            <li key={spacing} onClick={() => handleStyleTabTitleSizeSpacingSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="box-header-row">
                                <span>Caption Size</span>
                                <em onClick={toggleStyleTabCaptionSizeSpacingDropdown}>{selectedStyleTabCaptionSizeSpacing}</em>
                                {showStyleTabCaptionSizeSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"].map((spacing) => (
                                            <li key={spacing} onClick={() => handleStyleTabCaptionSizeSpacingSelect(spacing)}>
                                                {spacing}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "header" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i> Back</button> Header Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderBackgroundColor} setColor={setStyleHeaderBackgroundColor} onChangeComplete={handleHeaderBackgroundColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderTextColor} setColor={setStyleHeaderTextColor} onChangeComplete={handleHeaderTextColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveStyleCustomizeElementsTab("write_review_button")}>Write a Review Button <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "write_review_button" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i> Back</button> Write a Review Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderWriteReviewBackgroundColor} setColor={setStyleHeaderWriteReviewBackgroundColor} onChangeComplete={handleHeaderWriteReviewBackgroundColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Button Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderWriteReviewTextColor} setColor={setStyleHeaderWriteReviewTextColor} onChangeComplete={handleHeaderWriteReviewTextColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <p>Button Size</p>
                            <div className="left-cnater-right-button">
                                <label className="card-radio-btn">
                                    <input type="radio" name="header_review_button_type" className="card-input-element d-none" value="small" onChange={handleHeaderReviewButtonTypeChange} checked={activeHeaderReviewButtonType === "small"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Small</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="header_review_button_type" className="card-input-element d-none" value="medium" onChange={handleHeaderReviewButtonTypeChange} checked={activeHeaderReviewButtonType === "medium"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Medium</div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="header_review_button_type" className="card-input-element d-none" value="large" onChange={handleHeaderReviewButtonTypeChange} checked={activeHeaderReviewButtonType === "large"} />
                                    <div className="card card-body">
                                        <div className="content_sub">Large</div>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "rating" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Rating Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Stars Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderRatingStarsColor} setColor={setStyleHeaderRatingStarsColor} onChangeComplete={handleHeaderRatingStarsColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "review" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Review Settings</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewBackgroundColor} setColor={setStyleHeaderReviewBackgroundColor} onChangeComplete={handleReviewBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Review Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewTextColor} setColor={setStyleHeaderReviewTextColor} onChangeComplete={handleReviewTextColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Read More Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewReadMoreColor} setColor={setStyleHeaderReviewReadMoreColor} onChangeComplete={handleReviewReadMoreColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Reviewer Name Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewReviewerNameColor} setColor={setStyleHeaderReviewReviewerNameColor} onChangeComplete={handleReviewReviewerNameColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Verified Badge Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewVerifiedBadgeColor} setColor={setStyleHeaderReviewVerifiedBadgeColor} onChangeComplete={handleReviewVerifiedBadgeColorChange} />
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Date Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewDateColor} setColor={setStyleHeaderReviewDateColor} onChangeComplete={handleReviewDateColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Source Icon Background Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleHeaderReviewSourceIconBackgroundColor} setColor={setStyleHeaderReviewSourceIconBackgroundColor} onChangeComplete={handleReviewSourceIconBackgroundColorChange} />
                                </div>
                            </div>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Rating Size</span>
                                <div className="color-pikr-box">
                                    <em onClick={toggleStyleTabRatingSizeSpacingDropdown}>{selectedStyleTabRatingSizeSpacing}</em>
                                    {showStyleTabRatingSizeSpacingDropdown && (
                                        <ul className="dropdown-list">
                                            {['Small', 'Medium', 'Large', 'X-Large'].map((spacing) => (
                                                <li key={spacing} onClick={() => handleStyleTabRatingSizeSpacingSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Review Text Font Size</span>
                                <div className="color-pikr-box">
                                    <em onClick={toggleStyleTabReviewTextFontSizeSpacingDropdown}>{selectedStyleTabReviewTextFontSizeSpacing}</em>
                                    {showStyleTabReviewTextFontSizeSpacingDropdown && (
                                        <ul className="dropdown-list">
                                            {["10px", "11px", "12px", "13px", "14px", "15px", "16px", "17px", "18px", "19px", "20px", "30px", "40px", "50px"].map((spacing) => (
                                                <li key={spacing} onClick={() => handleStyleTabReviewTextFontSizeSpacingSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "load_more" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Load More Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTabReviewButtonColor} setColor={setStyleTabReviewButtonColor} onChangeComplete={handleReviewLoadMoreBackgroundColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Button Text Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={styleTabReviewButtonTextColor} setColor={setStyleTabReviewButtonTextColor} onChangeComplete={handleReviewLoadMoreTextColorChange}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeStyleCustomizeElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveStyleCustomizeElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                        <p>Tip: It is recommended to use the CSS classes with the “es” prefix, as these are specially designed for stable customization. Please note, while these classes are intended to be more static, we cannot guarantee that they will remain unchanged in future updates.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;